import {
  oddCrystalsResourceNames,
  preBonusRssNames,
  preBonusSharedResources,
  preBonusStoneResources,
  PreBonusTypes,
} from '../../../core/gameConstants';
import {
  PRE_BONUS_CRYSTALS_STATE,
  FREE_SPINS_STATE,
  MULTIPLIER_STATE,
} from '../../../stateManagment/gameState';
import { FONT_BALOO_NAME, FONT_LATO_NAME } from '../../../core/constats';
import {getTranslation, translationKeys} from '../../../core/translation/translation';
import { BaseComponentDrawer } from '../../../core/abstraction/BaseComponentDrawer';
import {gameDrawer} from "../../../game/GameDrawer";

export class BasePreBonusContentDrawer extends BaseComponentDrawer {
  constructor() {
    super();
    this.bonusElements = [
      {
        img: preBonusRssNames.preBonusCrystalYellow,
        observerName: oddCrystalsResourceNames.odd2,
      },
      {
        img: preBonusRssNames.preBonusCrystalGreen,
        observerName: oddCrystalsResourceNames.odd3,
      },
      {
        img: preBonusRssNames.preBonusCrystalBlue,
        observerName: oddCrystalsResourceNames.odd5,
      },
      {
        img: preBonusRssNames.preBonusCrystalMagenta,
        observerName: oddCrystalsResourceNames.odd60,
      },
    ];

    this.config = {
      titleDefaultStyle: {
        fontFamily: FONT_LATO_NAME,
        fill: [0xFEFEFD, 0x9B7853],
        stroke: '#dec195',
        strokeThickness: 1,
        fontSize: 24,
        align: 'center',
      },
      style: {
        [PreBonusTypes.magentaCrystal]: {
          fontFamily: FONT_BALOO_NAME,
          fill: 0xFFFFFF,
          stroke: '#E019E7',
          strokeThickness: 11,
          fontSize: 60,
          align: 'center',
          fontWeight: 900,
        },
        [PreBonusTypes.greenCrystal]: {
          fontFamily: FONT_BALOO_NAME,
          fill: 0xFFFFFF,
          stroke: '#139216',
          strokeThickness: 11,
          fontSize: 60,
          align: 'center',
          fontWeight: 900,
        },
        [PreBonusTypes.yellowCrystal]: {
          fontFamily: FONT_BALOO_NAME,
          fill: 0xFFFFFF,
          stroke: '#A27006',
          strokeThickness: 11,
          fontSize: 60,
          align: 'center',
          fontWeight: 900,
        },
      },
    };

  }

  async loadResource() {
    if (!this.resources) {
      const { res } = await super.loadResource([...preBonusSharedResources, ...preBonusStoneResources], this.loader);
      this.resources = res;
    }
    return this.resources;
  }

  getDiamond({ name, scale = 1 }) {
    const image = this.createSprite(this.resources[name]);
    image.scale.set(scale);
    image.anchor.set(.5);
    return image;
  }

  getPreBonusContent({
    percent = 64,
    size,
  }) {
    const contentImage = this.createSprite(this.resources[preBonusRssNames.preBonusBack]);
    const goldImage = this.createSprite(this.resources[preBonusRssNames.preBonusGold]);
    const scale = 100 / percent * size / contentImage.width;

    contentImage.anchor.set(.5);
    goldImage.anchor.set(.5);
    contentImage.scale.set(scale);
    goldImage.scale.set(scale);

    return [contentImage, goldImage];
  }

  getPreBonus({
      size: { w, h, m1 = 16, m2 = 24, sidePercent = 21 } = {},
      scale = .7,
      contentScale = 1,
      imgSize = { x: 32, y: 30 },
    },
  ) {
    const titleStyle = {
      fill: [0xfefefd, 0x9b7853],
      fontFamily: FONT_LATO_NAME,
      stroke: '#dec195',
      strokeThickness: 1,
      fontSize: 24,
      align: 'center',
    };

    const sideWidth = w * sidePercent / 100;
    const sideHeight = h - 2 * (h * .20);

    const container = this.createContainer('pre_Bonus');
    const contentContainer = this.createContainer('contentContainer');
    const multiPlayerContainer = this.createContainer('multiPlayerContainer');
    const freeSpinContainer = this.createContainer('freeSpinContainer');
    const crystalsContainer = this.createContainer('crystalsContainer');

    const freeSpinImage = this.createSprite(this.resources[preBonusRssNames.preBonusFreeSpinContent]);
    const multiPlayerImage = this.createSprite(this.resources[preBonusRssNames.preBonusMultiplierContent]);
    const crystalsContentImage = this.createSprite(this.resources[preBonusRssNames.preBonusCrystalsContent]);
    const contentImage = this.createSprite(this.resources[preBonusRssNames.preBonus_content]);

    contentImage.scale.set(contentScale);
    freeSpinImage.scale.set(scale);
    multiPlayerImage.scale.set(scale);
    crystalsContentImage.scale.set(scale);

    contentImage.anchor.set(.5);
    crystalsContentImage.anchor.set(.5);
    multiPlayerImage.anchor.set(.5);
    freeSpinImage.anchor.set(.5);

    this.setPosition(contentContainer, { x: w / 2, y: h / 2 });
    this.setPosition(freeSpinContainer, { x: sideWidth / 2, y: sideHeight / 2 + m1 / 2 });
    this.setPosition(multiPlayerContainer, { x: sideWidth / 2, y: sideHeight + 2 * m1 });
    this.setPosition(crystalsContainer, { x: w - sideWidth / 2, y: h / 2 });

    contentContainer.addChild(contentImage);
    multiPlayerContainer.addChild(multiPlayerImage);
    crystalsContainer.addChild(crystalsContentImage);
    freeSpinContainer.addChild(freeSpinImage);

    const multiplierTitle = new this.PIXI.Text(`${getTranslation(translationKeys.multiplier)}`, titleStyle);
    multiplierTitle.anchor.set(.5, 1.55);
    multiPlayerContainer.addChild(multiplierTitle);

    const multiplierValue = new this.PIXI.Text(0, {
      fill: [0xffffff, 0xB37AF5],
      fontFamily: FONT_BALOO_NAME,
      stroke: '#FFFFFF',
      strokeThickness: 2,
      fontSize: 65,
      align: 'center',
    });
    multiplierValue.anchor.set(.5, .25);
    multiPlayerContainer.addChild(multiplierValue);


    const freeSpinsTitle = new this.PIXI.Text(`${getTranslation(translationKeys.freeSpins)}`, titleStyle);
    freeSpinsTitle.anchor.set(.5, 1.55);
    freeSpinContainer.addChild(freeSpinsTitle);

    const freeSpinsValue = new this.PIXI.Text(0, {
      fill: [0xffffff, 0x58C4D1],
      fontFamily: FONT_BALOO_NAME,
      stroke: '#FFFFFF',
      strokeThickness: 2,
      fontSize: 65,
      align: 'center',
    });
    freeSpinsValue.anchor.set(.5, .25);
    freeSpinContainer.addChild(freeSpinsValue);

    this.addSubscriber(FREE_SPINS_STATE.subscribe((v) => {
      freeSpinsValue.text = v;
    }, true));
    this.addSubscriber(MULTIPLIER_STATE.subscribe((v) => {
      multiplierValue.text = v;
    }, true));


    this.bonusElements.forEach(({ img: name, observerName }, index) => {
      const text = new this.PIXI.Text(0, {
        fill: [0xfefefd, 0x9b7853],
        fontFamily: FONT_BALOO_NAME,
        fontWeight: 200,
        stroke: '#fefefd',
        strokeThickness: .5,
        fontSize: 24,
        align: 'center',
        dropShadowColor: 0x000000,
        dropShadowAlpha: .5,
        dropShadowBlur: 2,
        dropShadowDistance: 2,
        dropShadow: true,
        dropShadowAngle: Math.PI / 2,
      });
      const img = this.getDiamond({ name, scale: .7 });
      this.addSubscriber(PRE_BONUS_CRYSTALS_STATE.subscribe(({ [observerName]: value }) => {
        text.text = value ? `x${value}` : '0';
      }, true));

      text.anchor.set(.5);
      const y = sideHeight / 4 + imgSize.y - index * sideHeight / 4;
      const x = -sideWidth / 2 + imgSize.x;
      this.setPosition(img, { x, y });
      this.setPosition(text, { x: x + 65, y });
      crystalsContainer.addChild(img, text);
    });

    container.addChild(
      contentContainer,
      multiPlayerContainer,
      freeSpinContainer,
      crystalsContainer,
    );
    return container;
  }
}
